<template>
  <div class="assigned-roles-cont">
    <p @click="showRoles"
       :class="{'opened': open}"
       class="role">
      <span v-if="isDefaultRole">{{$t('menu.defaultRole')}}</span>
      <span v-for="roleName in assignedRoles"
            v-if="setActive(roleName)"
            :key="roleName.id + 'name'">
        {{roleName.name}}
      </span>
      <chevron-icon :style="{transform: open ? 'rotate(180deg)' : 'none'}" :fill="open ? '#109CF1' : 'rgba(0, 82, 127, .4)'"></chevron-icon>
    </p>
    <transition name="fade">
      <div v-show="open" class="roles-wrap">
        <p class="title">
          {{$t('menu.sidebar.rolesToggleTitle')}}
        </p>

        <ul class="roles-list">
          <li class="role-item "
              :class="{'active': isDefaultRole}"
              @click="switchRole(defaultRole.primary_role_id)">
            {{$t('profile.statuses.admin')}}
          </li>
          <li class="role-item "
              :class="{'active': setActive(role)}"
              @click="switchRole(role.id)"
              v-for="role in assignedRoles" :key="role.id">
            <trim-item :string="role.name" :width="20"></trim-item>
<!--            <button class="role-control-btn"-->
<!--                    @click.prevent=""-->
<!--                    type="button">-->
<!--              <dots-icon @click.prevent=""></dots-icon>-->
<!--            </button>-->
          </li>
        </ul>
      </div>
    </transition>
  </div>
</template>

<script>
import {tokenAndRoute} from "../../mixins/utils/tokenAndRoute";
import {loaderMixin} from "../../mixins/utils/loaderMixin";

import chevronIcon from '../Svg/chevronIcon'
import trimItem from '../trimITem'
import dotsIcon from '../Svg/things/dotsIcon'

import {mapState,mapMutations, mapActions} from 'vuex'

  export default {
    name: 'assignedRolesToggler',
    props: {
      open: {
        type: Boolean
      }
    },
    mixins: [
      tokenAndRoute,
      loaderMixin
    ],
    components: {
      chevronIcon,
      trimItem,
      dotsIcon
    },
    computed: {
      ...mapState({
        assignedRoles: state => state.roles.assignedRoles,
        defaultRole: state => state.auth.user,
      }),
      isDefaultRole() {
        return (this.defaultRole.primary_role_id == this.defaultRole.active_role_id);
      }
    },
    methods: {
      ...mapActions({
        setActiveRole: 'roles/switchRole',
        getAssignedRoles: 'roles/getAssignedRoles',
        getOwnedDevices: 'things/getDevices',
        getProjects: 'projects/getProjects',
        // getAssignedDevices: 'things/getAssignedDevices'
      }),
      showRoles() {
        if (!this.open) {
          this.$emit('open')
        } else {
          this.$emit('close')
        }
      },
      setActive(role) {
        return (this.defaultRole.active_role_id == role.id)
      },
      async switchRole(id) {
        this.showLoader()
        this.$router.push('/')
        this.setActiveRole({token: this.token, id});
        await this.getOwnedDevices({token: this.token});
        // await this.getAssignedDevices({token: this.token});
        await this.getProjects();
        this.hideLoader()
      }
    },
    mounted() {
      if (this.token) {
        this.getAssignedRoles(this.token)
      }
      // console.log(this.assignedRoles)
      // console.log(this.defaultRole)
    }
  }
</script>

<style lang="scss" scoped>


  .role {
    font-family: $mr;
    font-size: 12px;
    color: $darkBlue;
    white-space: nowrap;
    line-height: 14/12*100%;
    border-radius: 28px;

    padding: 5px 10px;
    max-height: 30px;
    min-height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }

  .opened {
    background: $lightGrey;
  }

  svg {
    margin-left: 5px;
    transition: $anim;
  }

  .roles-wrap {
    background: white;
    border-radius: 8px;
    box-shadow: 0px 4px 12px rgba(0, 82, 127, 0.2);
    padding: 20px 0;
    position: absolute;
    right: 0;
    top: 100%;
    max-width: 260px;
  }

  .title {
    font-family: $mm;
    font-size: 12px;
    letter-spacing: .15px;
    color: $darkBlue;
    opacity: .4;
    margin-bottom: 15px;
    text-align: center;
    padding: 0 20px;
    white-space: nowrap;
  }

  .role-item {
    height: 36px;
    padding: 0 20px;
    padding-left: 50px;
    position: relative;
    text-align: left;
    transition: $anim;
    cursor: pointer;
    display: flex;
    align-items: center;
    font-family: $msb;
    font-size: 12px;
    letter-spacing: .15px;
    color: $darkBlue;

    &::before {
      content: '';
      position: absolute;
      width: 14px;
      height: 14px;
      border-radius: 50%;
      left: 20px;
      top: 10px;
      border: 2px solid $grey;
    }

    &.active {
      color: $lightBlue;

      &::before {
        background: $lightBlue;
        border-color: white;
        box-shadow: 0px 4px 12px rgba(0, 82, 127, 0.2);
      }
    }

    &:hover {
      background: $lightGrey;
    }
  }
</style>
